var x = Object.defineProperty;
var d = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty,
  y = Object.prototype.propertyIsEnumerable;
var m = (t, r, e) => r in t ? x(t, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : t[r] = e,
  u = (t, r) => {
    for (var e in r || (r = {})) c.call(r, e) && m(t, e, r[e]);
    if (d) for (var e of d(r)) y.call(r, e) && m(t, e, r[e]);
    return t;
  };
function i(...t) {
  if (t) {
    let r = [];
    for (let e = 0; e < t.length; e++) {
      let a = t[e];
      if (!a) continue;
      let o = typeof a;
      if (o === "string" || o === "number") r.push(a);else if (o === "object") {
        let f = Array.isArray(a) ? [i(...a)] : Object.entries(a).map(([s, n]) => n ? s : void 0);
        r = f.length ? r.concat(f.filter(s => !!s)) : r;
      }
    }
    return r.join(" ").trim();
  }
}
function l(t) {
  return typeof t == "function" && "call" in t && "apply" in t;
}
function p({
  skipUndefined: t = !1
}, ...r) {
  return r == null ? void 0 : r.reduce((e, a = {}) => {
    for (let o in a) {
      let f = a[o];
      if (!(t && f === void 0)) if (o === "style") e.style = u(u({}, e.style), a.style);else if (o === "class" || o === "className") e[o] = i(e[o], a[o]);else if (l(f)) {
        let s = e[o];
        e[o] = s ? (...n) => {
          s(...n), f(...n);
        } : f;
      } else e[o] = f;
    }
    return e;
  }, {});
}
function w(...t) {
  return p({
    skipUndefined: !1
  }, ...t);
}
function E(...t) {
  return p({
    skipUndefined: !0
  }, ...t);
}
export { E as mergeDefaultProps, w as mergeProps };
